export default __webpack_public_path__ + "static/sobre-tecalis_04-736cae8e7270d45654bdd66e8bc58bfa.png";